import ImageIcon from '@mui/icons-material/Image';
import { Box, CardMedia } from '@mui/material';

import { isDefined } from 'common';

import { TEMPLATE_THUMBNAIL_ASPECT_RATIO } from '../constants';
import { decodeUrlPath } from '../utils';

export interface FlowTemplateCardThumbnailProps {
  image?: string;
  imageTimestamp?: string;
  width?: string;
  borderRadius?: number;
}

export function FlowTemplateCardThumbnail(props: FlowTemplateCardThumbnailProps) {
  const { image, imageTimestamp, width = '100%', borderRadius } = props;

  const commonStyles = {
    width,
    ...(isDefined(borderRadius) ? { borderRadius } : {}),
  };

  if (!isDefined(image)) {
    // Display placeholder with icon
    return (
      <Box
        sx={{
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...commonStyles,
        }}
        role="img"
      >
        <ImageIcon
          sx={{
            fontSize: 48,
            color: '#bdbdbd',
          }}
        />
      </Box>
    );
  }

  // Display actual image
  return (
    <CardMedia
      component="img"
      image={
        isDefined(imageTimestamp)
          ? `${decodeUrlPath(image)}?v=${imageTimestamp}`
          : decodeUrlPath(image)
      }
      alt=""
      sx={{
        objectFit: 'cover',
        aspectRatio: `${TEMPLATE_THUMBNAIL_ASPECT_RATIO}`,
        height: '100%',
        ...commonStyles,
      }}
    />
  );
}
